import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";

const NotFound: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["_messages"]);

  return (
    <Box
      sx={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          backgroundImage: "url(/public/images/404-background.webp)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.7) blur(1px)",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        }}
      />

      {/* Content */}
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          flexGrow: 1,
          zIndex: 1,
          color: "white",
          py: 8,
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: { xs: "4rem", sm: "6rem", md: "8rem" },
            fontWeight: 700,
            mb: 2,
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          404
        </Typography>

        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 500,
            mb: 4,
            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
          }}
        >
          {t("error_page_not_found")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 6,
            maxWidth: "600px",
            fontSize: "1.1rem",
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
          }}
        >
          {t("error_page_not_found_description")}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate({ to: "/app" })}
          sx={{
            px: 4,
            py: 1.5,
            fontWeight: 500,
            borderRadius: 2,
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              boxShadow: "0 6px 8px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          {t("action_back_to_home", { ns: "_action" })}
        </Button>
      </Container>
    </Box>
  );
};

export default NotFound;
